<template>
  <div>
    <div class="v2-InnerPadding dark">
      <div class="container">
        <Breadcrumbs class="dark breadcrumbs" />
      </div>
      <div class="offers-2 dark">
        <div>
          <div class="container">
            <div class="main-card-img">
              <picture>
                <source
                  class="img-absolute br-12"
                  media="(max-width: 767px)"
                  :srcset="
                    _.get(contentData, 'data.list[0].images[0].devices.mobile')
                  "
                />
                <source
                  class="img-absolute br-12"
                  media="(max-width: 1023px)"
                  :srcset="
                    _.get(contentData, 'data.list[0].images[0].devices.tablet')
                  "
                />
                <img
                  loading="lazy"
                  class="img-absolute br-12"
                  :src="
                    _.get(contentData, 'data.list[0].images[0].devices.desktop')
                  "
                  alt
                />
              </picture>
            </div>
            <div class="v2-offer-details">
              <div class="discount">
                {{ _.get(contentData, "data.list[0].discount") }}
              </div>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="v2-offer-content">
            <h1 class="font-38 tbc-medium lh-30">
              {{ _.get(contentData, "data.list[0].title") }}
            </h1>

            <div
              class="offer-info font-18 tbc-regular text"
              v-html="
                _.get(contentData, 'data.list[0].content.tabs[0].content')
              "
            ></div>
            <div class="table-title tbc-medium tbc-medium font-24">
              {{ _.get(contentData, "data.list[0].table_content[0].title") }}
            </div>
            <div
              class="table"
              v-if="
                _.get(
                  contentData,
                  'data.list[0].table_content[0].columnTitles[0]'
                )
              "
            >
              <div class="thead tr">
                <div class="td first-td uppercase font-16 ">
                  {{
                    _.get(
                      contentData,
                      "data.list[0].table_content[0].definitions"
                    )
                  }}
                </div>
                <div class="td uppercase font-16  xr-td">
                  {{
                    _.get(
                      contentData,
                      "data.list[0].table_content[0].columnTitles[0]"
                    )
                  }}
                </div>
                <div class="td uppercase font-16  mobile-td">
                  {{
                    _.get(
                      contentData,
                      "data.list[0].table_content[0].columnTitles[1]"
                    )
                  }}
                </div>
                <div class="td uppercase font-16 mobile-td">
                  {{
                    _.get(
                      contentData,
                      "data.list[0].table_content[0].columnTitles[2]"
                    )
                  }}
                </div>
                <div class="td plus"></div>
              </div>
              <template
                v-for="(item, index) in _.get(
                  this.contentData,
                  'data.list[0].table_content[0].data'
                )"
              >
                <div
                  class="tbody"
                  @click="changeActiveValue(index)"
                  :key="index"
                >
                  <div class="tr" :class="{ active: active === index }">
                    <div class="td first-td">
                      {{ tableData[index] }}
                    </div>
                    <div :key="index" class="td xr-td">
                      {{ item[0] }}
                    </div>
                    <div class="td mobile-td">
                      {{ item[1] }}
                    </div>
                    <div class="td mobile-td">
                      {{ item[2] }}
                    </div>
                    <div class="td plus" :class="{ active: active === index }">
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <div
                    class="mobile-list"
                    :class="{ active: active === index }"
                  >
                    <ul>
                      <li class="uppercase font-16 xr-reversed tbc-bold">
                        {{
                          _.get(
                            contentData,
                            "data.list[0].table_content[0].columnTitles[0]"
                          )
                        }}
                        <p class="font-16">{{ item[0] }}</p>
                      </li>
                      <li class="uppercase font-16 tbc-bold">
                        {{
                          _.get(
                            contentData,
                            "data.list[0].table_content[0].columnTitles[1]"
                          )
                        }}
                        <p class="font-16">{{ item[1] }}</p>
                      </li>
                      <li class="uppercase font-16 tbc-bold">
                        {{
                          _.get(
                            contentData,
                            "data.list[0].table_content[0].columnTitles[2]"
                          )
                        }}
                        <p class="font-16">{{ item[2] }}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </div>
            <div
              class="v2-bottom-text text"
              v-html="
                _.get(contentData, 'data.list[0].table_content[0].teaser')
              "
            ></div>
          </div>
          <InnerGallery :contentData="innerGalleryData" />

          <div class="flex-box al-center">
            <ShareTags :data="_.get(contentData, 'data.list[0].tags')" />
            <div
              class="back"
              @click="$router.push(`/${$store.state.main.locale}/offers`)"
            >
              <div class="animated-link">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                >
                  <path
                    id="Combined_Shape_Copy_2"
                    data-name="Combined Shape Copy 2"
                    d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.658a1.167,1.167,0,0,1-1.65,0Z"
                    transform="translate(0 0)"
                    fill="#00aeef"
                  />
                </svg>

                <span class="tbc-regular font-16">{{
                  $fn.tr("Back to offers")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs";
import ShareTags from "../ShareTags";
import InnerGallery from "./InnerGallery";

export default {
  props: ["evenOdd"],
  components: {
    Breadcrumbs,
    ShareTags,
    InnerGallery
  },
  data() {
    return {
      active: null,
      switchPage: false
    };
  },
  computed: {
    tableData() {
      let data = _.get(
        this.contentData,
        "data.list[0].table_content[0].rowTitles"
      );

      let singleRow = [];
      for (let index = 0; index < data.length; index++) {
        singleRow.push(data[index]);
      }
      return singleRow;
    },
    contentData() {
      return _.get(this.$store.state.main.current_content, "primary");
    },
    innerGalleryData() {
      let arr = [];
      let newArrayOfObj = _.get(this.contentData, "data.list");
      newArrayOfObj = newArrayOfObj
        ? newArrayOfObj.map(({ images: additional_images, ...rest }) => ({
            additional_images,
            ...rest
          }))
        : [];

      return { data: { list: newArrayOfObj } };
    }
  },
  methods: {
    changeActiveValue(index) {
      if (window.innerWidth < 768) {
        if (this.active === index) {
          this.active = "";
        } else {
          this.active = index;
        }
      }
    }
  },

  mounted() {
    this.$store.commit("main/setState", { key: "hideBreadcrumb", val: true });
    this.$store.commit("main/setState", { key: "isInner", val: true });
  },
  beforeDestroy() {
    this.$store.commit("main/setState", { key: "isInner", val: false });
    this.$store.commit("main/setState", { key: "hideBreadcrumb", val: false });
  }
};
</script>
<style scoped>
.back {
  width: 200px;
}
.back svg {
  transform: rotate(180deg);
}
.relative {
  position: relative;
}
.InnerPadding {
  padding: 32px 0 45px;
}
.breadcrumbs {
  margin-bottom: 55px;
  background: transparent !important;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
</style>

<style scoped>
.offers-1 {
  display: flex;
  justify-content: space-between;
}
.timer-width {
  width: 47%;
}
.left-content {
  width: calc(50% - 15px);
}
.right-content {
  width: calc(50% - 15px);
}
.inner-card-img {
  position: relative;
  padding-top: 694px;
  overflow: hidden;
}
.img-box {
  height: 100%;
  margin: 0 15px;
}
.company {
  margin-bottom: 20px;
}
.company-box {
  padding-bottom: 50px;
  padding-left: 100px;
}
.company-box img {
  object-fit: contain;
}
.right-content .all-offers {
  padding-bottom: 34px;
  margin-bottom: 34px;
  background-image: linear-gradient(
    to right,
    var(--border-dashes) 50%,
    var(--border-dashes1) 0%
  );
  background-position: bottom;
  background-size: 25px 2px;
  background-repeat: repeat-x;
}
.right-content h1 {
  color: var(--secondary);
  line-height: 36px;
  margin-bottom: 15px;
}
.right-content .discount-timer {
  display: flex;
  justify-content: space-between;
  padding-bottom: 21px;
  margin-bottom: 21px;
  background-image: linear-gradient(
    to right,
    var(--border-dashes) 50%,
    var(--border-dashes1) 0%
  );
  background-position: bottom;
  background-size: 25px 2px;
  background-repeat: repeat-x;
}
.right-content .discount {
  background: #686dfd;
  color: white;
  padding: 12px 22px;
  height: fit-content;
  max-width: 50%;
}
.right-content .text {
  color: var(--text-gray);
  line-height: 24px;
  opacity: 0.9;
  background-image: linear-gradient(
    to right,
    var(--border-dashes) 50%,
    var(--border-dashes1) 0%
  );
  background-position: bottom;
  background-size: 25px 2px;
  background-repeat: repeat-x;
  padding-bottom: 41px;
  margin-bottom: 34px;
}
.right-content .contacnt-h3 {
  color: var(--secondary);
}
.right-content .contacnt-h3 span {
  color: #e74c3c;
}
.right-content .share-links {
  margin-top: 99px;
  color: var(--svg-fill);
  display: flex;
}
.right-content >>> .share-links {
  border-bottom: unset;
}
.right-content .share-links svg {
  margin-left: 15px;
}

.partner-company {
  margin-right: 30px;
}
.all-offers-text {
  color: var(--tbc-blue);
  transition: 0.4s;
}

.all-offers-text svg {
  margin-left: 15px;
}
.all-offers-text svg path {
  fill: var(--tbc-blue);
}
@media screen and (max-width: 1439px) {
  .left-content {
    width: calc(50% - 11px);
  }
  .right-content {
    width: calc(50% - 19px);
  }
  .inner-card-img {
    padding-top: 578px;
  }
  .right-content .discount {
    padding: 10px 23px 9px;
  }
}
@media screen and (max-width: 1023px) {
  .breadcrumbs {
    margin-bottom: 34px;
  }
  .offers-1 {
    display: block;
  }
  .left-content {
    width: 100%;
  }
  .right-content {
    width: 100%;
  }
  .inner-card-img {
    padding-top: 60.4%;
    margin-bottom: 34px;
  }
  .right-content .discount-timer {
    justify-content: flex-start;
  }
  .right-content .discount {
    padding: 10px 20px 9px;
    margin-right: 30px;
  }
  .share-links {
    margin-top: 89px;
  }
}
@media screen and (max-width: 767px) {
  .back {
    margin-top: -30px;
  }
  .breadcrumbs {
    margin-bottom: 30px;
  }
  .right-content .all-offers {
    padding-bottom: 21px;
    margin-bottom: 21px;
  }
  .inner-card-img {
    padding-top: 61.4%;
  }
  .right-content h1 {
    font-size: 16px;
    line-height: 24px;
  }
  .right-content .discount-timer {
    justify-content: flex-start;
  }
  .right-content .discount {
    font-size: 16px;
    padding: 14px 9px 15px;
  }
  .right-content .text {
    padding-bottom: 17px;
    margin-bottom: 21px;
  }
  .share-links {
    margin-top: 54px;
  }
}
@media screen and (max-width: 413px) {
  .right-content .all-offers {
    padding-bottom: 24px;
    margin-bottom: 20px;
  }
  .inner-card-img {
    margin-bottom: 19px;
  }
  .right-content h1 {
    font-size: 16px;
    line-height: 24px;
  }
  .right-content .discount-timer {
    justify-content: flex-start;
  }
  .right-content .discount {
    margin-right: 20px;
  }
  .right-content .text {
    padding-bottom: 41px;
    margin-bottom: 23px;
  }
  .share-links {
    margin-top: 54px;
  }
}
</style>
<style scoped>
.relative {
  position: relative;
}
.v2-InnerPadding {
  padding: 32px 0 34px;
  padding-bottom: 0;
}
.breadcrumbs {
  margin-bottom: 55px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}

.main-card-img {
  position: relative;
  padding-top: 450px;
  overflow: hidden;
  margin-bottom: 34px;
}
.all-offers-text,
.all-offers-text svg path {
  color: var(--tbc-blue);
  fill: var(--tbc-blue);
}
.all-offers-text svg {
  margin-left: 5px;
}
.v2-offer-details {
  display: flex;
  padding-bottom: 47px;
}
.v2-offer-details .discount {
  color: var(--tbc-blue);
  font-size: 18px;
}
.company-img {
  position: relative;
  padding-top: 44px;
  margin-bottom: 25px;
  min-width: 142px;
}
.v2-other-offers p {
  margin-bottom: 5px;
  color: var(--secondary);
}
.v2-company-banner {
  padding: 0 71.5px 0 0px;
  background-image: linear-gradient(
    to top,
    var(--border-dashes) 50%,
    var(--border-dashes1) 0%
  );
  background-position: right;
  background-size: 3px 21px;
  background-repeat: repeat-y;
}
.v2-discount-timer {
  padding: 0 67px 0 71.5px;
  background-image: linear-gradient(
    to top,
    var(--border-dashes) 50%,
    var(--border-dashes1) 0%
  );
  background-position: right;
  background-size: 3px 21px;
  background-repeat: repeat-y;
}
.v2-discount {
  background: #686dfd;
  color: white;
  padding: 10px 15px 10px 13px;
  width: fit-content;
  margin-bottom: 25px;
}
.v2-questions {
  padding-left: 93px;
}
.v2-questions .question-info p {
  margin-bottom: 2px;
  color: var(--text-gray);
}
.v2-questions .question-info {
  margin-bottom: 17px;
}
.v2-questions .question-info span {
  color: var(--secondary);
}
.v2-questions .question-info h3 {
  color: var(--text-gray);
}
.v2-number-info p {
  margin-bottom: 2px;
  color: var(--text-gray);
}
.v2-number-info .phone-number {
  display: flex;
}
.v2-number-info .phone-number svg {
  margin-right: 10px;
}
.v2-number-info .phone-number p {
  color: var(--tbc-blue);
}
.v2-offer-content h1 {
  color: var(--secondary);
  margin: 38px 0 55px;
  line-height: 38px;
}
.v2-offer-content .offer-info {
  color: rgba(218, 218, 218, 0.8);
  margin-bottom: 53px;
}
.v2-offer-content .contacnt-h3 {
  color: var(--secondary);
  margin-bottom: 11px;
}
.v2-offer-content .contacnt-h3 span {
  color: #e74c3c;
}
.v2-bottom-text {
  padding-bottom: 25px;
}
.table-title {
  margin-bottom: 38px;
  color: #dadada;
}
.table {
  margin-bottom: 34px;
  width: 100%;
  border: 1px solid #364756;
}
.table .tr {
  display: flex;
}
.table .tr .td {
  width: 25%;
  padding: 20px 20px;
  text-align: center;
  border-right: 1px solid #364756;
  align-items: center;
  display: flex;
  justify-content: center;
}

.table .tr .td:first-child {
  text-align: left;
  justify-content: end;
}
.table .tr .td:first-child:not(.font-16) {
  font-size: 16px;
}

.table .tbody .tr.active {
  background: var(--tbc-blue);
}
.table .tbody .tr.active .td {
  color: white;
}
.table .tbody .tr.active .plus span {
  background: white;
}
.plus span:nth-child(2) {
  opacity: 1;
  transition: 0.8s cubic-bezier(0.15, -0.01, 0, 0.99);
}
.plus.active span:nth-child(2) {
  opacity: 0;
  transition: 0.8s cubic-bezier(0.15, -0.01, 0, 0.99);
}
.table .thead {
  background: #24313d;
}
.table .tbody {
  overflow: hidden;
}
.table .tr:nth-child(even) {
  background: #24313d;
}
.table .tbody:nth-child(odd) {
  background: #24313d;
}
.table .tbody:nth-child(even) {
  background: transparent;
}
.table .td {
  color: var(--secondary);
  text-align: center;
  width: 25%;
}

.table .td {
  padding: 21px 20px 22px;
  border-right: 1px solid #364756;
}
.table .td:first-child {
  text-align: left;
}
.table .td:last-child {
  border: none;
}
.table .tr .plus {
  width: 37px;
  position: relative;
  padding: 0;
}
.table .tr .plus {
  display: none;
}
.plus span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.plus span:nth-child(1) {
  width: 10px;
  height: 2px;
  background: var(--secondary);
}
.plus span:nth-child(2) {
  width: 2px;
  height: 10px;
  background: var(--secondary);
}
.mobile-list {
  max-height: 0;
  transition: 0.8s cubic-bezier(0.15, -0.01, 0, 0.99);
}
.mobile-list ul {
  display: flex;
  flex-wrap: wrap;
}
.mobile-list ul li {
  padding: 19px 20px 18px;
}
.mobile-list ul li p {
  margin-top: 5px;
}
.xr-reversed {
  display: none !important;
}
@media screen and (max-width: 1439px) {
  .main-card-img {
    padding-top: 41%;
  }
  .v2-company-banner {
    padding: 0 50.5px 0 0px;
  }
  .v2-discount-timer {
    padding: 0px 40px 0 48px;
  }
  .v2-questions {
    padding-left: 60px;
  }
  .v2-offer-content h1 {
    margin: 55px 0 25px;
  }
}
@media screen and (max-width: 1023px) {
  .breadcrumbs {
    margin-bottom: 34px;
  }
  .main-card-img {
    padding-top: 40%;
  }
  .v2-company-banner {
    padding: 0 25px 0 0px;
  }
  .v2-discount-timer {
    padding: 0px 2px 0 22px;
    min-width: 155px;
  }
  .v2-questions {
    padding-left: 18px;
  }
  .v2-bottom-text {
    padding-bottom: 0;
  }
  .share-links {
    margin-top: 89px;
  }
  .table .tr .td {
    padding: 25px 10px 18px;
  }
  .table .tr .first-td {
    min-width: 195px;
    padding: 25px 20px 18px;
  }
}
@media screen and (max-width: 767px) {
  .breadcrumbs {
    margin-bottom: 30px;
  }
  .mobile-td {
    display: none !important;
  }
  .mobile-list.active {
    max-height: 500px;
    transition: 1s;
  }
  .table .tr .td {
    width: 100%;
    padding: 25px 20px 18px;
  }
  .table .tr .plus {
    width: 37px;
    min-width: 37px;
    position: relative;
    display: block;
    padding: 0;
  }
  .main-card-img {
    padding-top: 41.5%;
    margin-bottom: 21px;
  }
  .v2-company-banner {
    padding: 0 31px 0 0px;
  }
  .v2-offer-content h1 {
    margin: 29px 0 25px;
    font-size: 16px;
    line-height: 27px;
  }
  .v2-offer-details {
    padding-bottom: 18px;
    flex-direction: column;
  }
  .v2-offer-details .flex {
    margin-bottom: 10px;
  }
  .v2-discount-timer {
    padding: 0px 0px 0 31px;
  }
  .v2-questions .question-info {
    margin-right: 40px;
  }
  .v2-questions {
    padding-left: 0px;
    padding-top: 19px;
    display: flex;
    background-image: linear-gradient(
      to right,
      var(--border-dashes) 50%,
      var(--border-dashes1) 0%
    );
    background-position: top;
    background-size: 25px 2px;
    background-repeat: repeat-x;
  }
  .question-info h3,
  .question-info span {
    font-size: 16px;
  }
  .v2-bottom-text {
    padding-bottom: 0;
  }
  .v2-discount-timer {
    background-image: none;
  }
  .share-links {
    margin-top: 54px;
  }
}
@media screen and (max-width: 413px) {
  .xr-td {
    display: none !important;
  }
  .xr-reversed {
    display: block !important;
  }
  .v2-company-banner {
    padding: 0 15px 0 0px;
  }
  .v2-discount-timer {
    padding: 0px 0px 0 20px;
    min-width: 100px;
  }
  .v2-questions .question-info {
    margin-right: 5px;
  }
  .v2-number-info .phone-number svg {
    margin-right: 5px;
  }
  .share-links {
    margin-top: 54px;
  }
}
</style>
<style>
.offers-inn .share-tags-cont {
  max-width: unset !important;
}
</style>
